import React from 'react';
import { styled } from 'styled-components';
export function WayPointsList({
  readonly,
  draggable,
  disableGap,
  children
}) {
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: [disableGap ? '' : 'space', draggable ? 'shifted' : '', readonly ? 'readonly' : ''].filter(Boolean).join(' ')
  }, children);
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  hr {
    margin-left: 26px;
  }

  > svg {
    position: absolute;
    left: 0;
  }

  &.space {
    gap: 16px;
  }

  &.shifted {
    hr {
      margin-left: 48px;
    }

    > svg {
      left: 22px;
    }
  }
`;